/* eslint-disable react-hooks/rules-of-hooks */
import { graphql, useStaticQuery } from "gatsby"
import { useMergePrismicPreviewData } from "gatsby-plugin-prismic-previews"

export const orderInstructions = () => {
  const staticData = useStaticQuery(
    graphql`
      query OrderInstructions {
        prismicOrderInstructions {
          _previewable
          data {
            title {
              text
            }
            paynow_instructions {
              richText
            }
            paynow_details {
              richText
            }
            paynow_qr {
              alt
              gatsbyImageData(height: 300, layout: FIXED)
            }
            stripe_instructions {
              richText
            }
          }
        }
      }
    `
  )

  const { data } = useMergePrismicPreviewData(staticData)
  return data.prismicOrderInstructions.data
}
